export default __webpack_public_path__ + "static/owner_and_guest_user_policies-6672bfe0949c9fdafab60eb29acd1039.svg";